import httpService from '@/services/HttpService';
import {
    AnswerRequest, AnswerResponse,
    QuestionResponse,
    RegisterRequest, RegisterResponse,
    TokenRequest, TokenResponse } from '@/models';

const baseApiPath = process.env.VUE_APP_API_PATH || '';

export class ClientRegisterService {

    public async token(request: TokenRequest): Promise<TokenResponse> {
        const response = await httpService.axios.post<TokenResponse>(
            baseApiPath + '/api/client-register/token',
            request);
        return response.data;
    }

    public async question(token: string): Promise<QuestionResponse> {
        const response = await httpService.axios.get<QuestionResponse>(
            baseApiPath + '/api/client-register/question',
            { headers: this.createHeaders(token) });
        return response.data;
    }

    public async answer(request: AnswerRequest, token: string): Promise<AnswerResponse> {
        const response = await httpService.axios.post<AnswerResponse>(
            baseApiPath + '/api/client-register/answer',
            request,
            { headers: this.createHeaders(token) });
        return response.data;
    }

    public async register(request: RegisterRequest, token: string): Promise<RegisterResponse> {
        const response = await httpService.axios.post<RegisterResponse>(
            baseApiPath + '/api/client-register/register',
            request,
            { headers: this.createHeaders(token) });
        return response.data;
    }

    private createHeaders(token: string): any {
        return {
            'omni-client-register': token
        };
    }
}

const clientRegisterService = new ClientRegisterService();
export default clientRegisterService;
